/**
 * Where the bottom tab bar is — and isn't.
 *
 * Shared by TabsLayout (which hides the bar) and the PWA update banner (which
 * must sit above the bar when it's there, and stay out of the way entirely on
 * the full-page chats). Keeping the predicate in one place stops the two from
 * drifting apart.
 */

/** Tab bar height, excluding the safe-area inset. Mirrors TabsLayout's CSS. */
export const TAB_BAR_HEIGHT_PX = 64;

/**
 * Full-page chats: the AkbAI Assistant and any Messages sub-page (a direct
 * thread, a group thread, or the group members list). These hide the tab bar
 * and own the bottom edge with a composer footer, so a floating banner would
 * cover the input. The Messages list itself (/tabs/messages exactly) is not a
 * composer route.
 */
export function isComposerRoute(path: string): boolean {
  return path.startsWith('/tabs/assistant') || path.startsWith('/tabs/messages/');
}

/** True when the bottom tab bar is rendered for this route. */
export function isTabBarVisible(path: string): boolean {
  return path.startsWith('/tabs') && !isComposerRoute(path);
}
